import React, { Fragment, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RequireFreshPassword from "./components/RequireFreshPassword";

// Telas novas (UI Consumidor Final)
const Login = lazy(() => import("./pages/login/Login.new"));
const BemVindo = lazy(() => import("./pages/onboarding/Welcome"));
const Tutorial = lazy(() => import("./pages/onboarding/Tutorial"));
const Cadastro = lazy(() => import("./pages/login/Cadastro.new"));
const CadastroSucesso = lazy(() => import("./pages/login/CadastroSucesso"));
const RecuperarSenha = lazy(() => import("./pages/login/RecuperarSenha.new"));
const PswRecover = lazy(() => import("./pages/login/PswRecover"));
const SenhaAlterada = lazy(() => import("./pages/login/SenhaAlterada"));
const AlterarSenha = lazy(() => import("./pages/login/AlterarSenha"));
const Home = lazy(() => import("./pages/home/Home.new"));
const Perfil = lazy(() => import("./pages/perfil/Perfil"));
const Notificacoes = lazy(() => import("./pages/notificacoes/Notificacoes"));
const AbrirChamado = lazy(() => import("./pages/chamados/AbrirChamado"));
const ListaChamados = lazy(() => import("./pages/chamados/ListaChamados.new"));
const ExibeChamado = lazy(() => import("./pages/chamados/ExibeChamado.new"));
const ListaCertificados = lazy(() => import("./pages/certificados/ListaCertificados.new"));
const ExibeCertificado = lazy(() => import("./pages/certificados/ExibeCertificado.new"));
const ListaGarantias = lazy(() => import("./pages/garantias/ListaGarantias.new"));
const Certificado = lazy(() => import("./pages/certificado/Certificado.new"));
const Suporte = lazy(() => import("./pages/suporte/Suporte.new"));
const Busca = lazy(() => import("./pages/busca/Busca.new"));
const Revisao = lazy(() => import("./pages/revisao/Revisao.new"));
const ChatBoot = lazy(() => import("./pages/chatBoot/chatBoot"));

const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Fragment>
          <Routes>
            {/* Onboarding */}
            <Route path="/" element={<BemVindo />} />
            <Route path="/tutorial" element={<Tutorial />} />

            {/* Autenticação */}
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro" element={<Cadastro />} />
            <Route path="/cadastro-sucesso" element={<CadastroSucesso />} />
            <Route path="/recuperar-senha" element={<RecuperarSenha />} />
            <Route path="/psw-recover/:token" element={<PswRecover />} />
            <Route path="/senha-alterada" element={<SenhaAlterada />} />
            <Route path="/alterar-senha" element={<AlterarSenha />} />

            {/* App principal — todas protegidas pelo RequireFreshPassword:
                redireciona pra /alterar-senha enquanto force_password_change=1,
                ou pra /login se nao houver token. */}
            <Route path="/home" element={<RequireFreshPassword><Home /></RequireFreshPassword>} />
            <Route path="/perfil" element={<RequireFreshPassword><Perfil /></RequireFreshPassword>} />
            <Route path="/notificacoes" element={<RequireFreshPassword><Notificacoes /></RequireFreshPassword>} />

            {/* Chamados */}
            <Route path="/abrir-chamado" element={<RequireFreshPassword><AbrirChamado /></RequireFreshPassword>} />
            <Route path="/lista-chamados" element={<RequireFreshPassword><ListaChamados /></RequireFreshPassword>} />
            <Route path="/exibe-chamado" element={<RequireFreshPassword><ExibeChamado /></RequireFreshPassword>} />

            {/* Certificados / Garantias */}
            <Route path="/certificado" element={<RequireFreshPassword><Certificado /></RequireFreshPassword>} />
            <Route path="/lista-certificados" element={<RequireFreshPassword><ListaCertificados /></RequireFreshPassword>} />
            <Route path="/exibe-certificado" element={<RequireFreshPassword><ExibeCertificado /></RequireFreshPassword>} />
            <Route path="/lista-garantias" element={<RequireFreshPassword><ListaGarantias /></RequireFreshPassword>} />
            <Route path="/exibe-garantia" element={<RequireFreshPassword><ExibeCertificado /></RequireFreshPassword>} />

            {/* Suporte / Outros */}
            <Route path="/suporte" element={<RequireFreshPassword><Suporte /></RequireFreshPassword>} />
            <Route path="/busca" element={<RequireFreshPassword><Busca /></RequireFreshPassword>} />
            <Route path="/revisao" element={<RequireFreshPassword><Revisao /></RequireFreshPassword>} />
            <Route path="/chat-boot" element={<RequireFreshPassword><ChatBoot /></RequireFreshPassword>} />

            {/* Atalhos legados */}
            <Route path="/reparo" element={<RequireFreshPassword><AbrirChamado /></RequireFreshPassword>} />
            <Route path="/chamado" element={<RequireFreshPassword><AbrirChamado /></RequireFreshPassword>} />
          </Routes>
        </Fragment>
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
